export default {
  NEW: 'NEW',
  SUBMITTED: 'SUBMITTED',
  CONFIRMED: 'CONFIRMED',
  WAITING: 'WAITING',
  PAID: 'PAID',
  CANCELED: 'CANCELED',
};
